import { useCallback } from 'react';

export const useSwissNumberFormatter = () => {
    const formatSwissNumber = useCallback((number: number) => {
        return new Intl.NumberFormat('de-CH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    }, []);

    return { formatSwissNumber };
};
